<template>
  <div>
    <CCol sm="12" class="mb-3">
      <CRow class="d-flex justify-content-start">
        <p class="d-flex align-items-center mr-4 mb-0"><u>Filtrar por: </u></p>
        <!-- Filters -->
        <CRow class="d-flex flex-grow-1">
          <DropdownFilter class="mt-1 mb-1" title="Data de Inicio" :index="6" mode="date" @option-changed="startDateChanged" :defaultDate="defaultStartDate"></DropdownFilter>  
          <DropdownFilter class="mt-1 mb-1" title="Data de Fim" :index="7" mode="date" @option-changed="endDateChanged" :defaultDate="defaultEndDate"></DropdownFilter> 
          <DropdownFilter class="mt-1 mb-1" title="Tarefas" :index="8" :options="tasks" @option-changed="taskChanged"></DropdownFilter> 
          <DropdownFilter class="mt-1 mb-1" title="Locais" :index="9" :options="places" @option-changed="placeChanged"></DropdownFilter> 
          <DropdownFilter class="mt-1 mb-1" title="Recursos Humanos" :index="10" :options="people" @option-changed="personChanged"></DropdownFilter>  
          <DropdownFilter class="mt-1 mb-1" title="Ferramentas" :index="11" :options="tools" @option-changed="toolChanged"></DropdownFilter>  
        </CRow> 
        <!-- Action buttons -->
        <button type="button" class="ml-1 mr-1 btn btn-primary" @click="callExportExcel">Exportar EXCEL</button>
        <button type="button" class="ml-1 mr-1 btn btn-primary" @click="seeGraph = !seeGraph">{{viewModeLabel}}</button>
        <button v-if="loadedFilters" type="button" class="ml-1 mr-1 btn btn-primary" @click="addInfo">Adicionar Novo</button>
      </CRow>
    </CCol>
    <!-- List mode -->
    <CRow v-show="!seeGraph" v-bind:class="{'mt-3': numberHours || numberCost, 'mt-5': !numberHours && !numberCost}">
      <CCol>
        <!-- Cost and hours -->
        <p v-if="numberHours" class="col-lg-12 p-0 my-2"><b>Número de horas:</b> {{numberHours}}</p>
        <p v-if="numberCost" class="col-lg-12 p-0 my-2"><b>Custo total:</b> {{numberCost}}</p>
        <p v-for="(toolDetail, value) in toolDetails" class="col-lg-12 p-0 my-2" :key="value"><b>{{value}}:</b> {{toolDetail}}</p>
        <!-- List -->
        <CTableWrapper v-show="!seeGraph" ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :loading="loading" :sorter="{external: true}" :defaultSorterValue="sorterValue" @sorter-value-changed="sorterValueChanged">   
        </CTableWrapper>
      </CCol>
    </CRow>
    <!-- Graph mode -->
    <CRow v-show="seeGraph" class="mt-5">
      <CCol>
        <!-- Graph -->
        <CChartLine id="chart" :datasets="costHoursDataset" labels="days" :options="{ maintainAspectRatio: false, scales: { xAxes: xAxes }}"/>
        <div v-show="loading" class="spinner-background">
          <CSpinner color="primary" grow/>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
 
<script>
import moment from 'moment';
import { CChartLine } from '@coreui/vue-chartjs'
import { mapState, mapActions } from 'vuex';
import CTableWrapper from '../controls/PaginatedTable.vue';
import SearchBar from '../controls/SearchBar.vue';
import DropdownFilter from '../controls/DropdownFilter.vue';
import router from '@/router';
import InputGetOperations from '@/classes/InputGetOperations';
import { UTILS_HELPER } from "@/helpers/utils.js";
import InputGetTasks from "@/classes/InputGetTasks";
import InputGetPlaces from "@/classes/InputGetPlaces";
import InputGetPeople from "@/classes/InputGetPeople";
import InputGetTools from "@/classes/InputGetTools";
import { saveAs } from 'file-saver';
import InputGetOperationsCost from '@/classes/InputGetOperationsCost';

export default {
  components: { CTableWrapper, SearchBar, DropdownFilter, CChartLine },
  data () {
    return {
      searchText: '',
      toolDetailsLabel: '',
      toolDetailsValue: '',
      caption: 'Tarefas',
      itemsPerPage: 10,
      currentPageAux: 0,
      fields: [
        { key: 'readableDate', label: 'Data', _classes: 'font-weight-bold', sorter: true },
        { key: 'tasks', label: 'Tarefas', sorter: false },
        { key: 'places', label: 'Locais', sorter: false },
        { key: 'people', label: 'Recursos Humanos', sorter: false },
        { key: 'tools', label: 'Ferramentas', sorter: false }
  ],
      actions: [
        { key: 'view', label: 'Ver' },
        { key: 'remove', label: 'Apagar' }
      ],
      sorterValue: { column: 'readableDate', asc: true },
      defaultStartDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      startDate: null, 
      endDate: null,
      task: null,
      place: null,
      person: null,
      tool: null,
      loading: false,
      seeGraph: false
    }
  },
  computed: {
    ...mapState({
      operationListOutput: state => state.operations.listOutput,
      tasksListOutput: state => state.tasks.listOutput,
      placesListOutput: state => state.places.listOutput,
      peopleListOutput: state => state.people.listOutput,
      toolsListOutput: state => state.tools.listOutput
    }),
    ...mapState('operations', ['saveStartDate']),
    ...mapState('operations', ['saveEndDate']),
    ...mapState('operations', ['removeTask']),
    ...mapState('operations', ['exportExcelOutput']),
    ...mapState('operations', ['listSummaryOutput']),
    ...mapState('operations', ['listCostsSummary']),
    operationsInfo: function(){
      return this.operationListOutput && this.operationListOutput.obj ? this.operationListOutput.obj : null;
    },
    items: function() {
      var result = null;

      if(this.operationsInfo)
      {
        result = this.operationsInfo.operations;

        result.forEach(operation => {
          operation["readableDate"] = UTILS_HELPER.formatDate(operation.date);
        });
      }

      return result;
    },
    pages: function()
    {
      return this.operationsInfo ? this.operationsInfo.pagesNumber : 1;
    },
    numberHours: function()
    {
      return this.operationsInfo ? `${this.operationsInfo.hours}h` : null;
    },
    numberCost: function()
    {
      return this.operationsInfo ? `${this.operationsInfo.cost.toFixed(2)}€` : null;
    },
    toolDetails: function ()
    {
      return this.operationsInfo && this.operationsInfo.toolDetails ? this.operationsInfo.toolDetails : null;
    },
    loadedFilters: function()
    {
      return this.tasks.length && this.places.length && this.people.length && this.tools.length;
    },
    tasks: function()
    {
      var result = [];

      if(this.tasksListOutput && this.tasksListOutput.obj)
      {
        this.tasksListOutput.obj.tasks.forEach(task => result.push({"key": task.id, "text": task.name}));
      }

      return result;
    },
    places: function()
    {
      var result = [];

      if(this.placesListOutput && this.placesListOutput.obj)
      {
        this.placesListOutput.obj.places.forEach(place => result.push({"key": place.id, "text": place.name}));
      }

      return result;
    },
    people: function()
    {
      var result = [];

      if(this.peopleListOutput && this.peopleListOutput.obj)
      {
        this.peopleListOutput.obj.users.forEach(person => result.push({"key": person.id, "text": person.name}));
      }

      return result;
    },
    tools: function()
    {
      var result = [];

      if(this.toolsListOutput && this.toolsListOutput.obj)
      {
        this.toolsListOutput.obj.tools.forEach(tool => result.push({"key": tool.id, "text": tool.name}));
      }

      return result;
    },
    viewModeLabel: function()
    {
      return this.seeGraph ? "Ver tabela" : "Ver gráfico";
    },
    costHoursDataset () {
      var result = 
      [
        {
          label: 'Horas',
          backgroundColor: 'rgb(228,102,81,0.9)',
        },
        {
          label: 'Custos',
          backgroundColor: 'rgb(0,216,255,0.9)',
        }
      ];

      if(this.listCostsSummary && this.listCostsSummary.obj)
      {
        result[0]["data"] = this.listCostsSummary.obj.dayCosts.map(dayCost => dayCost.hours);
        result[1]["data"] = this.listCostsSummary.obj.dayCosts.map(dayCost => dayCost.cost);
      }

      return result;
    },
    minTicks: function()
    {
      var date = new Date(this.startDate);
      return date.getTime();
    },
    maxTicks: function()
    {
      var date = new Date(this.endDate);
      return date.getTime();
    },
    xAxes(){
      // Note that the following html was not working:
      /*
      <CChartLine id="chart" :datasets="costHoursDataset" :options="{ maintainAspectRatio: false, scales: { xAxes: [{type: 'time', time: {format: 'DD/MM/YYYY', unit: 'day', parser: 'DD/MM/YYYY', min: startDate, max: endDate }}]} }"/>
      */

      var labels = this.listCostsSummary && this.listCostsSummary.obj ? this.listCostsSummary.obj.dayCosts.map(dayCost => dayCost.date) : [];

      return [{
        type: 'category',
        labels: labels,
      }];
    }
  },
  mounted: function()
  {
    // router.beforeEach((to, from, next) => {
    //   if(from.name == "ViewOperations" && to.name == "ListOperations")
    //   {
    //     console.log("GUARDAR DATA")
    //     this.UpdateDate(this.date)
    //   }
    //   next();
    // })
    // Update list
    this.updateItemsRequested(1, this.itemsPerPage);

    // Get items for filters
    this.getTasks(new InputGetTasks(1, 999, null, null, 0));
    this.getPlaces(new InputGetPlaces(1, 999, null, null, 0));
    this.getPeople(new InputGetPeople(1, 999, null, null, 0));
    this.getTools(new InputGetTools(1, 999, null, null, 0));
},
  methods: {
    ...mapActions({
      'getOperations': 'operations/getList',
      'getTasks': 'tasks/getList',
      'getPlaces': 'places/getList',
      'getPeople': 'people/getList',
      'getTools': 'tools/getList'

}),
    ...mapActions('operations', ['updateFirstDate']),
    ...mapActions('operations', ['updateEndDate']),
    ...mapActions('operations', ['getListCosts']),
    ...mapActions('operations', ['removeOperation']),
    ...mapActions('operations', ['exportExcel']),
    rowClicked (item, index) {
      this.$router.push({name: "ViewOperations", params: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "ViewOperations", params: { id: item.id } });
          break;
        }
        case 'remove':
        {
          if(confirm(`Tem a certeza que pretende apagar o item selecionado?`)){
            this.loading = true;
            this.removeOperation(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      this.loading = true;
      this.itemsPerPage = itemsPerPage;
      this.currentPageAux = currentPage;

      var taskKey = this.task ? this.task.key : null;
      var placeKey = this.place ? this.place.key : null;
      var personKey = this.person ? this.person.key : null;
      var toolKey = this.tool ? this.tool.key : null;

      var input = new InputGetOperations(currentPage, itemsPerPage, this.startDate, this.endDate, taskKey, placeKey, personKey, toolKey, this.sorterValue.asc ? 0 : 1);
      this.getOperations(input); 

    },
    updateGraphRequested()
    {
      this.loading = true;

      var taskKey = this.task ? this.task.key : null;
      var placeKey = this.place ? this.place.key : null;
      var personKey = this.person ? this.person.key : null;
      var toolKey = this.tool ? this.tool.key : null;

      var input = new InputGetOperationsCost(this.startDate, this.endDate, taskKey, placeKey, personKey, toolKey);
      this.getListCosts(input); 
    },
    addInfo () 
    {
      router.push({ path: '/operacoes/adicionar' });
    },
    startDateChanged(val)
    {
      this.startDate = val;
      this.updateFirstDate(this.startDate);

      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    endDateChanged(val)
    {
      this.endDate = val;
      this.updateEndDate(this.endDate);

      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    taskChanged(val)
    {
      this.task = val;

      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    placeChanged(val)
    {
      this.place = val;

      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    personChanged(val)
    {
      this.person = val;

      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    toolChanged(val)
    {
      this.tool = val;
      if(this.seeGraph)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },  
    callExportExcel()
    {
      this.loading = true;

      var taskKey = this.task ? this.task.key : null;
      var placeKey = this.place ? this.place.key : null;
      var personKey = this.person ? this.person.key : null;
      var toolKey = this.tool ? this.tool.key : null;

      var input = new InputGetOperations(null, null, this.startDate, this.endDate, taskKey, placeKey, personKey, toolKey, null);
      this.exportExcel(input);
    },
    saveExcelFile(val)
    {
      var fileSaver = require('file-saver');
      var file = new File([UTILS_HELPER.s2ab(btoa(unescape(encodeURIComponent(val))))], "Operacoes.xlsx", {type: "application/vnd.ms-excel;charset=utf-8"});
      fileSaver.saveAs(file);
    },
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    operationListOutput: function(val)
    {
      this.loading = false
    },
    listCostsSummary: function(val)
    {
      this.loading = false;
    },
    removeTask: function(val)
    {
      if(val)
      {
        this.updateItemsRequested(this.currentPageAux, this.itemsPerPage);
      }
      else
      {
        if(val == false)
        {
          alert("Algo correu mal ao apagar o item selecionado. Por favor tente novamente.");
        }

        this.loading = false;
      }
    },
    exportExcelOutput: function(val)
    {
      this.loading = false;
    },
    seeGraph: function(val)
    {
      if(val)
      {
        this.updateGraphRequested();
      }
      else
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    saveStartDate:
    {
      handler(val)
      {
        if(val)
        {
          let dateMomentObject = moment(val, "DD/MM/YYYY"); 
          let dateConversion = dateMomentObject.toDate();
          this.defaultStartDate = dateConversion; 
          this.startDate = UTILS_HELPER.formatDate(this.defaultStartDate);
        }
        else{
          this.defaultStartDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
          this.startDate = UTILS_HELPER.formatDate(this.defaultStartDate);
        }
      },
      immediate: true
    },
    saveEndDate:
    {
      handler(val)
      {
        if(val)
        {
          let dateMomentObject = moment(val, "DD/MM/YYYY"); 
          let dateConversion = dateMomentObject.toDate();
          this.defaultEndDate = dateConversion; 
          this.endDate = UTILS_HELPER.formatDate(this.defaultEndDate);
        }
        else{
          this.defaultEndDate = new Date();
          this.endDate = UTILS_HELPER.formatDate(this.defaultEndDate);
        }
      },
      immediate: true
    },
  }
}
</script>

 
<style>

th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

#chart
{
  height: 60vh;
  width: 100%;
}

.spinner-background
{
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.5);
}
</style> 